import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin, Briefcase, Clock } from "lucide-react";
import { motion } from "framer-motion";
import { useLanguage } from "@/context/LanguageContext";
import { sectorLabel, contractLabel, jobField, formatProvince, formatPublishedDate } from "@/data/content";

export default function JobCard({ job, index = 0 }) {
  const { lang } = useLanguage();
  const title = jobField(job, "title", lang);
  const province = formatProvince(job.province, lang);
  const publishedDate = formatPublishedDate(job.published_at || job.created_at, lang);
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay: index * 0.06 }}
    >
      <Link
        to={`/offres/${job.id}`}
        data-testid={`job-card-${job.id}`}
        className="group block bg-y5-surface border border-y5-line p-8 transition-all duration-300 hover:border-y5-yellow hover:bg-y5-surfaceHover"
      >
        <div className="flex items-start justify-between gap-4 mb-6">
          <span className="inline-block bg-y5-yellow/10 text-y5-yellow text-xs font-semibold uppercase tracking-wider px-3 py-1.5">
            {sectorLabel(job.sector, lang)}
          </span>
          <ArrowUpRight className="text-white/40 group-hover:text-y5-yellow group-hover:translate-x-1 group-hover:-translate-y-1 transition-all" />
        </div>
        <h3 className="font-display text-2xl leading-tight mb-4 group-hover:text-y5-yellow transition-colors uppercase">
          {title}
        </h3>
        <div className="flex flex-wrap gap-x-5 gap-y-2 text-sm text-y5-muted">
          <span className="flex items-center gap-2">
            <MapPin size={15} /> {job.location}{province ? `, ${province}` : ""}
          </span>
          <span className="flex items-center gap-2"><Briefcase size={15} /> {contractLabel(job.contract_type, lang)}</span>
        </div>
        {publishedDate && (
          <div className="flex items-center gap-2 text-xs text-y5-muted mt-3 pt-3 border-t border-y5-line/60">
            <Clock size={13} /> {publishedDate}
          </div>
        )}
      </Link>
    </motion.div>
  );
}
